<template>
  <div class="wareManageDetailPage">
    <div class="my-swipe">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item
          class="swiper-slide"
          v-for="(item, index) in bannerList"
          :key="index"
          ><van-image width="100%" height="345" :src="item"
        /></van-swipe-item>
      </van-swipe>
    </div>

    <div class="main_content">
      <div class="good_description">
        <div class="item">
          <p>商品ID：{{ shopItem.id }}</p>
          <p>商品名称：{{ shopItem.commodityname }}</p>
        </div>
        <div class="item">
          <div class="block">
            <p>排序：{{ shopItem.sort }}</p>
            <p>所属企业：{{ shopItem.qy_accountid }}</p>
            <p>是否上架：{{ shopItem.commoditystate }}</p>
            <p>销售状态：{{ shopItem.salestate }}</p>
          </div>
          <div class="block">
            <p>是否精品推荐：{{ shopItem.isintro }}</p>
            <p>是否置顶：{{ shopItem.istop == 1 ? "是" : "否" }}</p>
            <p>是否限购：{{ shopItem.islimit }}</p>
            <p>SKU采购编码：{{ shopItem.sku }}</p>
            <p>品牌标签：{{ shopItem.brandname }}</p>
          </div>
        </div>
        <div class="item">
          <div class="block">
            <p>ISBN编码：{{ shopItem.ISBN }}</p>
          </div>
          <div class="block">
            <p>
              所属分类：{{
                this.label_name(
                  shopItem.labelid,
                  shopItem.labelid2,
                  shopItem.labelid3
                )
              }}
            </p>
            <p>商品类型：{{ shopItem.comtype }}</p>
            <p>结算类型：{{ shopItem.paytype }}</p>
            <p>基础零售价：{{ shopItem.price }}</p>
            <p>普通用户积分兑换值：{{ shopItem.userscore1 }}</p>
            <p>商务合作用户积分兑换值：{{ shopItem.userscore2 }}</p>
          </div>
          <div class="block">
            <p>企业积分兑换值：{{ shopItem.userscore3 }}</p>
            <p>基础批发价：{{ shopItem.pfprice }}</p>
            <p class="flex-between">
              <span>单款混选起批数量：{{ shopItem.startnum2 }}</span
              ><span>件/起批</span>
            </p>

            <!-- <p class="flex-between">
              <span>批发商品组规格：{{ shopItem.groupnum }}</span
              ><span>件/每组</span>
            </p>
            <p>批发售价：{{ shopItem.groupprice }}</p>
            <p class="flex-between">
              <span>单样单选起批数量：{{ shopItem.startnum2 }}</span
              ><span>组</span>
            </p>
            <p class="flex-between">
              <span>混样多选起批数量：{{ shopItem.startnum2 }}</span
              ><span>组</span>
            </p> -->
          </div>
        </div>
      </div>
      <div class="good_total">
        <p>
          <span>当前库存总量：</span><span>{{ realnum }}</span
          ><span>件</span>
        </p>
      </div>
      <div class="good_detail">
        <div class="tit">明细数据：</div>
        <div class="list" v-if="detailList.length > 0">
          <div class="item" v-for="item in detailList" :key="item.id">
            <p>数量：{{ item.num }}件</p>
            <p>
              位置：<span>{{ item.whid1_str }}</span> <span v-if="item.whid2_str">/{{ item.whid2_str }}</span> <span v-if="item.whid3_str">/{{
                item.whid3_str
              }}</span> <span v-if="item.whid4_str">/{{ item.whid4_str }}</span>
            </p>
            <p>
              属性参数：<span>{{ item.ams_shop_commodity_attrid_str }}</span>
              <span>{{ item.ams_shop_commodity_attr_value_str }}</span>
            </p>
            <p>商品批次：{{ item.makerno }}</p>
            <p>生产商：{{ item.makername_str }}</p>
          </div>
        </div>
        <van-empty description="暂无数据" v-else />
        <!-- <div class="noData" v-else>暂无数据</div> -->
      </div>
    </div>

    <div class="">
    <!-- <div class="return-fixd"> -->
      <div class="primary-button" @click="handleGo">设置入库参数</div>
      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i>返回
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  getMenuAuthTwo,
  queryShopWareRecord,
  queryShop,
  getCommondityLabel,
} from "../../api/api";
export default {
  name: "wManageDetail",
  data() {
    return {
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      bannerList: "", // 商品banner
      brandList: "", // 品牌列表
      shopLabelFirst: "", // 商品所属分类
      shopItem: "",

      keyword: "",
      realnum: 0,
      detailList: [],
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { keyword } = this.$route.params;
    this.keyword = keyword;
    this.getShopLabel();
    this.getShopDetail(keyword);
    this.getWearRecord(keyword);

    this.roleId = this.$store.state.USERINFO.roleid;
    this.menuItem = this.$store.state.menuItem;
    this.getMenuAuthTwo();
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    // 获取商品详情
    getShopDetail(keyword) {
      queryShop({ keyword, openid: this.OPENID,  qyguid: this.$store.state.USERINFO.qy.qyguid }).then((res) => {
        let bannerList = [];
        bannerList.push(res.banner);
        bannerList.push(res.banner2);
        bannerList.push(res.banner3);
        bannerList.push(res.banner4);
        bannerList.push(res.banner5);
        let filter = bannerList.filter((v) => v != "");
        this.bannerList = filter;
        this.shopItem = res;
      });
    },
    // 入库记录
    getWearRecord(keyword) {
      queryShopWareRecord({ keyword, qyguid: this.$store.state.USERINFO.qy.qyguid }).then((res) => {
        let num = 0;
        if (res.length > 0) {
          res.forEach((v) => {
            num += v.num;
          });
          this.realnum = num;
        }
        this.detailList = res;
      });
    },

    // 获取商品分类标签
    getShopLabel() {
      getCommondityLabel().then((res) => {
        this.shopLabelFirst = res;
      });
    },
    // 商品所属分类
    label_name(id, id2, id3) {
      let { shopLabelFirst } = this;
      if (shopLabelFirst.length > 0 && id) {
        // 一级分类
        let filter = shopLabelFirst.filter((v) => v.id == id);
        if (filter.length > 0) {
          if (id2) {
            // 二级分类
            let filter2 = filter[0].childs2.filter((v) => v.id == id2);
            if (filter2.length > 0) {
              if (id3) {
                // 三级分类
                let filter3 = filter2[0].childs3.filter((v) => v.id == id3);
                return (
                  filter[0].labelname +
                  "、" +
                  filter2[0].labelname +
                  "、" +
                  filter3[0].labelname
                );
              }
              return filter[0].labelname + "、" + filter2[0].labelname;
            }
          }
          return filter[0].labelname;
        }
      }
    },
    handleGo() {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$toast("暂无权限");
        return;
      }
      this.$router.push(`/warehousIndex/wManageSettingList/${this.keyword}`);
    },
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.wareManageDetailPage {
  padding-bottom: 320px;
  .main_content {
    padding: 69px 69px 140px;
    .good_description {
      font-size: 22px;
      color: #404d6c;
      .item {
        margin-bottom: 100px;
        p {
          margin-bottom: 9px;
        }
        .block {
          margin-bottom: 35px;
        }
      }
    }
  }

  .good_total {
    font-size: 30px;
    margin-bottom: 50px;
  }
  .good_detail {
    font-size: 22px;
    .tit {
      font-size: 30px;
      margin-bottom: 30px;
    }
    .item {
      border-top: 1px solid #bebebe;
      padding: 25px 0;
      p {
        margin-bottom: 20px;
      }
    }
  }
}
</style>